<ng-container *transloco="let t">
  <div class="result-list-item">
    <div class="result-list-item__distance">
      <app-header-badge [text]="'42 km'" [customClass]="'w-100'" />
    </div>
    <div class="result-list-item__desc">
      <div class="fw-bold fs-18-16 pb-16">
        @if(race){
        <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [itLabel]="race.nameIta"
        [srLabel]="race.nameSr"
        [bsLabel]="race.nameBs"
          [siLabel]="race.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" />
        }@else {
        <span>-</span>
        }
      </div>
      <ul class="square-list square-list--inline">
        @if(race?.sport){
        <li class="text-uppercase fw-semibold">
          <small>{{ t("app.common.sports." + race?.sport) }}</small>
        </li>
        }
        @if (eventItem?.leagueName || eventItem?.leagueNameEn || eventItem?.leagueNameSl || eventItem?.leagueNameIt || eventItem?.leagueNameSr ) {
        <li>
          <app-language-output [hrLabel]="eventItem?.leagueName" [enLabel]="eventItem?.leagueNameEn"
            [itLabel]="eventItem?.leagueNameIt" [siLabel]="eventItem?.leagueNameSl" [srLabel]="eventItem?.leagueNameSr" [bsLabel]="eventItem?.leagueNameBs"
            [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
          @if (eventItem?.round !== null && eventItem?.round !== undefined) {
          {{ "-" + eventItem?.round }}
          }
        </li>
        }

      </ul>
      <div class="race-details">
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16">
              {{
              race && race.raceStart ? (race!.raceStart |
              localizedDate:'short')
              : '-'
              }}
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16"> Running marathon
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16">
              <span>
                {{ race?.length | raceLengthFormat:translocoService.getActiveLang() }}
              </span>
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16">
              Rio de Janeiro, BRA
            </div>
          </div>
        </div>
        <div class="race-details__item">
          <div class="race-details__content">
            <div class="fs-16">
              BIB/ 2356
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-table">
      <div class="header cell">Time</div>
      <div class="data cell">2:55:12,45</div>

      <div class="header cell">Ranking</div>
      <div class="data cell">136</div>

      <div class="header cell">Category</div>
      <div class="data cell">M55</div>

      <div class="header cell">Points</div>
      <div class="data cell">-</div>
    </div>
  </div>
</ng-container>
